// extracted by mini-css-extract-plugin
export default {"wrapper":"f1-z","boldPrefix":"g1-z","link":"h1-z","message":"i1-z","image":"j1-z"};